import moment from "moment";
import { Link } from "react-router-dom";

import "moment/locale/pt-br";
import "./styles.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faAt,
    faEye,
    faHistory,
    faHome,
    faPhone,
    faSearch,
    faUser,
    faComments,
    faHashtag,
    faInfoCircle,
    faPlus,
} from "@fortawesome/free-solid-svg-icons";

import HistoricoCardPage from "../../CardsPages/Historico";
import { IComponentModal } from "../../Modais/IModalComponent";
import {
    detectarTagsHtml,
    formatedTelefone,
    formatMoneyReais,
    retirarTagsHtml,
} from "../../../Tools/FormatTools";
import React from "react";
import { IAtendimentoGenerico } from "../../../Interfaces/Geral/Atendimento/AtendimentoInterfaces";
import { useState } from "react";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import DOMPurify from "dompurify";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import CopyToClipboard from "../../Utils/CopyToClipboard";
import { ColumnDescription } from "react-bootstrap-table-next";
import HTMLRemover from "../../Utils/HTMLRemover";
import { ACESSOS } from "../../../Routes/Acessos";

export type ModuloAtendimento =
    | "Cobranca"
    | "Atendimento"
    | "AssistenciaTecnica"
    | "Repasse"
    | "EntregaChaves";

interface IAtendimentoCardProps {
    atendimento: IAtendimentoGenerico;
    moduloAtendimento: ModuloAtendimento;
    setShow: (show: boolean) => void;
    setModal: (modal: IComponentModal) => void;
    children?: React.ReactNode;
    atalhos?: Array<{
        icon: IconProp;
        text: string;
        action: (a: IAtendimentoGenerico) => void;
        condition?: (a: IAtendimentoGenerico) => boolean;
    }>;
    adicionalButton?: (row: IAtendimentoGenerico) => JSX.Element;
    compactar?: boolean;
    hideHistoricoNumber?: boolean;
}

function AtendimentoCard(props: IAtendimentoCardProps) {
    moment.locale("pt-br");

    const [leiaMais, setLeiaMais] = useState({
        dsCaso: false,
        historico: false,
    });

    const { atendimento, setModal, setShow } = props;

    const DS_IS_HTML = detectarTagsHtml(atendimento.DS_CASO);
    const showDS = DS_IS_HTML
        ? retirarTagsHtml(atendimento.DS_CASO)
        : atendimento.DS_CASO;

    const ULTIMO_HIS_IS_HTML = detectarTagsHtml(
        atendimento.DS_ULTIMO_HISTORICO || ""
    );
    const showULT_HIS = ULTIMO_HIS_IS_HTML
        ? retirarTagsHtml(atendimento.DS_ULTIMO_HISTORICO || "")
        : atendimento.DS_ULTIMO_HISTORICO;
    const showDsContato =
        atendimento.CONTA.DS_CONTATO !== atendimento.CONTA.DS_NOME;

    return (
        <div key={atendimento.ID_CASO}>
            <div className="card gutter-b card-stretch">
                <div className="card-header p-1 ribbon ribbon-top ribbon-ver">
                    <div
                        className="card-toolbar mb-2 ml-3 mr-3"
                        style={{ height: "40px" }}
                    >
                        <div className="d-flex align-items-center justify-content-end">
                            <OverlayTrigger
                                overlay={
                                    <Tooltip
                                        id="tooltip-disabled"
                                        className="d-md-flex flex-column"
                                    >
                                        <div className="d-flex flex-column font-size font-weight-bold d-lg-flex">
                                            <div>
                                                <FontAwesomeIcon
                                                    icon={faUser}
                                                    className="svg-icon svg-icon-md svg-icon-gray-500 mr-1 d-lg-flex"
                                                />
                                                {atendimento.DS_ATENDENTE}
                                            </div>
                                            <div>
                                                <FontAwesomeIcon
                                                    icon={faComments}
                                                    className="svg-icon svg-icon-md svg-icon-gray-500 mr-1 d-lg-flex"
                                                />
                                                {
                                                    atendimento.DS_CANAL_ATENDIMENTO
                                                }
                                            </div>
                                            <div>
                                                <FontAwesomeIcon
                                                    icon={faHashtag}
                                                    className="svg-icon svg-icon-md svg-icon-gray-500 mr-1 d-lg-flex"
                                                />
                                                {atendimento.ID_CASO}
                                            </div>
                                        </div>
                                    </Tooltip>
                                }
                            >
                                <div className="d-flex d-lg-none text-primary">
                                    <FontAwesomeIcon
                                        icon={faInfoCircle}
                                        size="2x"
                                        className="svg-icon svg-icon-md svg-icon-gray-500 mr-1 d-lg-flex"
                                    />
                                </div>
                            </OverlayTrigger>
                            {(props.atalhos || props.compactar) && (
                                <div
                                    className="dropdown dropdown-inline"
                                    data-toggle="tooltip"
                                    title=""
                                    data-placement="left"
                                    data-original-title="Quick actions"
                                >
                                    <a
                                        href="#/"
                                        className="btn btn-clean btn-hover-light-primary btn-sm btn-icon"
                                        data-toggle="dropdown"
                                        aria-expanded="false"
                                    >
                                        <i className="ki ki-bold-more-hor"></i>
                                    </a>
                                    <div className="dropdown-menu dropdown-menu-sm dropdown-menu-right ">
                                        <ul className="navi navi-hover">
                                            <li className="navi-header pb-1">
                                                <span className="text-primary text-uppercase font-weight-bold font-size-sm">
                                                    Atalhos
                                                </span>
                                            </li>
                                            {props.compactar && (
                                                <>
                                                    <li
                                                        className="navi-item"
                                                        role="button"
                                                        onClick={() => {
                                                            setModal({
                                                                Component: () =>
                                                                    HistoricoCardPage(
                                                                        {
                                                                            ID_CASO:
                                                                                atendimento.ID_CASO,
                                                                        }
                                                                    ),
                                                                headerComponent:
                                                                    "Históricos",
                                                                IconHeader:
                                                                    faHistory,
                                                                collapseForm:
                                                                    true,
                                                                size: "lg",
                                                            });
                                                            setShow(true);
                                                        }}
                                                    >
                                                        <span className="navi-link">
                                                            <span className="navi-icon">
                                                                <FontAwesomeIcon
                                                                    className="mr-2"
                                                                    icon={
                                                                        faHistory
                                                                    }
                                                                />
                                                            </span>
                                                            <span className="navi-text">
                                                                Histórico do
                                                                caso
                                                            </span>
                                                        </span>
                                                    </li>
                                                    <li className="navi-item">
                                                        <Link
                                                            to={`/${props.moduloAtendimento}/Atendimento/${atendimento.ID_CASO}`}
                                                        >
                                                            <span className="navi-link">
                                                                <span className="navi-icon">
                                                                    <FontAwesomeIcon
                                                                        className="mr-2"
                                                                        icon={
                                                                            faEye
                                                                        }
                                                                    />
                                                                </span>
                                                                <span className="navi-text">
                                                                    Ver
                                                                    Atendimento
                                                                </span>
                                                            </span>
                                                        </Link>
                                                    </li>
                                                </>
                                            )}
                                            {props.atalhos &&
                                                props.atalhos
                                                    .filter(
                                                        (atalho) =>
                                                            !atalho.condition ||
                                                            atalho.condition(
                                                                atendimento
                                                            )
                                                    )
                                                    .map((atalho) => (
                                                        <li
                                                            className="navi-item"
                                                            onClick={() =>
                                                                atalho.action(
                                                                    atendimento
                                                                )
                                                            }
                                                            key={atalho.text}
                                                            role="button"
                                                        >
                                                            <span className="navi-link">
                                                                <span className="navi-icon">
                                                                    <FontAwesomeIcon
                                                                        className="mr-2"
                                                                        icon={
                                                                            atalho.icon
                                                                        }
                                                                    />
                                                                </span>
                                                                <span className="navi-text">
                                                                    {
                                                                        atalho.text
                                                                    }
                                                                </span>
                                                            </span>
                                                        </li>
                                                    ))}
                                        </ul>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="d-flex flex-wrap justify-content-between m-1">
                        <div className="d-flex flex-column">
                            <span className="text-dark-75 font-size-h4">
                                {showDsContato && atendimento.CONTA.DS_CONTATO}
                                <CopyToClipboard className="ml-2">
                                    {showDsContato
                                        ? atendimento.CONTA.DS_CONTATO
                                        : ""}
                                </CopyToClipboard>
                            </span>
                            <span className="card-title font-weight-bolder font-size-h3 text-dark mb-1">
                                {!props.compactar
                                    ? atendimento.CONTA.DS_NOME
                                    : ""}
                                <CopyToClipboard className="ml-2">
                                    {!props.compactar
                                        ? atendimento.CONTA.DS_NOME
                                        : ""}
                                </CopyToClipboard>
                            </span>

                            <div className="tel-email">
                                {atendimento.CONTA.DS_EMAIL &&
                                    atendimento.CONTA.DS_EMAIL[0] && (
                                        <OverlayTrigger
                                            overlay={
                                                <Tooltip
                                                    id="email-tooltip"
                                                    className={`cliente-tooltip ${
                                                        atendimento.CONTA
                                                            .DS_EMAIL.length <=
                                                            1 &&
                                                        "tooltip-disabled"
                                                    } `}
                                                >
                                                    <div className="d-flex flex-column">
                                                        {atendimento.CONTA.DS_EMAIL.map(
                                                            (email) => {
                                                                return (
                                                                    <span
                                                                        key={
                                                                            email
                                                                        }
                                                                    >
                                                                        {email}
                                                                    </span>
                                                                );
                                                            }
                                                        )}
                                                    </div>
                                                </Tooltip>
                                            }
                                            trigger={["click"]}
                                        >
                                            <span
                                                className="label label-light-dark label-inline"
                                                style={{ height: "auto" }}
                                            >
                                                <FontAwesomeIcon
                                                    icon={faAt}
                                                    className="mr-1"
                                                />
                                                {atendimento.CONTA.DS_EMAIL[0]}
                                                {atendimento.CONTA.DS_EMAIL
                                                    .length > 1 && (
                                                    <FontAwesomeIcon
                                                        icon={faPlus}
                                                        className="ml-2"
                                                    />
                                                )}
                                            </span>
                                        </OverlayTrigger>
                                    )}
                                {atendimento.CONTA.NR_TELEFONE &&
                                    atendimento.CONTA.NR_TELEFONE[0] && (
                                        <OverlayTrigger
                                            overlay={
                                                <Tooltip
                                                    id="email-tooltip"
                                                    className={`cliente-tooltip ${
                                                        atendimento.CONTA
                                                            .NR_TELEFONE
                                                            .length <= 1 &&
                                                        "tooltip-disabled"
                                                    } `}
                                                >
                                                    <div className="d-flex flex-column">
                                                        {atendimento.CONTA.NR_TELEFONE.map(
                                                            (phone) => {
                                                                return (
                                                                    <span
                                                                        key={
                                                                            phone
                                                                        }
                                                                    >
                                                                        {formatedTelefone(
                                                                            phone
                                                                        )}
                                                                    </span>
                                                                );
                                                            }
                                                        )}
                                                    </div>
                                                </Tooltip>
                                            }
                                            trigger={["click"]}
                                        >
                                            <span
                                                className="label label-light-dark label-inline"
                                                style={{ height: "auto" }}
                                            >
                                                <FontAwesomeIcon
                                                    icon={faPhone}
                                                    className="mr-1"
                                                />
                                                {formatedTelefone(
                                                    atendimento.CONTA
                                                        .NR_TELEFONE[0]
                                                )}
                                                {atendimento.CONTA.NR_TELEFONE
                                                    .length > 1 && (
                                                    <FontAwesomeIcon
                                                        icon={faPlus}
                                                        className="ml-2"
                                                    />
                                                )}
                                            </span>
                                        </OverlayTrigger>
                                    )}
                            </div>
                        </div>

                        <div
                            className={`ribbon-target-mult`}
                            style={{ top: "-2px", right: "45px" }}
                        >
                            <div
                                className={`ribbon-target ribbonCustom d-none d-lg-flex ${
                                    atendimento.DS_STATUS_CASO === "Aberto"
                                        ? "bg-warning"
                                        : "bg-success"
                                }`}
                            >
                                {atendimento.DS_STATUS_CASO}
                            </div>

                            {atendimento.DS_ATENDENTE && (
                                <div className="ribbon-target ribbonCustom d-none d-lg-flex bg-gray-600">
                                    <FontAwesomeIcon
                                        icon={faUser}
                                        className="mr-2"
                                    />{" "}
                                    {atendimento.DS_ATENDENTE}
                                </div>
                            )}

                            <div className="ribbon-target ribbonCustom d-none d-lg-flex bg-gray-700">
                                Atendimento - {atendimento.ID_CASO}
                            </div>
                            {atendimento.DS_CANAL_ATENDIMENTO && (
                                <div className="ribbon-target ribbonCustom d-none d-lg-flex bg-gray-800">
                                    {atendimento.DS_CANAL_ATENDIMENTO}
                                </div>
                            )}

                            {atendimento.ID_CHAVE_ERP_VENDA && (
                                <div className="ribbon-target ribbonCustom d-none d-lg-flex bg-dark">
                                    {atendimento.ID_CHAVE_ERP_VENDA}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className="card-body padding-1x">
                    <div className="d-flex flex-column flex-wrap mt-3">
                        <div className="d-flex flex-wrap flex-lg-nowrap mt-1">
                            <div className="mr-12 d-flex flex-wrap mb-2">
                                <div className="d-flex flex-wrap flex-column mb-2">
                                    <span className="d-block font-weight-bold mb-1 ">
                                        Data início
                                    </span>
                                    <span className="label label-light-primary label-inline mr-2 my-1 ws-nowrap">
                                        {moment(atendimento.DT_INICIO).format(
                                            "lll"
                                        )}
                                    </span>
                                </div>
                                {atendimento.DT_FIM && (
                                    <div className="d-flex flex-wrap flex-column">
                                        <span className="d-block font-weight-bold mb-1">
                                            Data Final
                                        </span>
                                        <span className="label label-light-success label-inline mr-2 my-1 ws-nowrap">
                                            {moment(atendimento.DT_FIM).format(
                                                "lll"
                                            )}
                                        </span>
                                    </div>
                                )}
                            </div>
                            {!props.compactar && (
                                <div className="mr-6 d-flex flex-column">
                                    {atendimento.DS_CASO && (
                                        <div className="d-flex flex-wrap flex-column mb-2">
                                            <span className="d-flex align-items-center font-weight-bold mb-1">
                                                Descrição
                                                {DS_IS_HTML && (
                                                    <span
                                                        className="text-primary ml-1 btn p-0"
                                                        onClick={() => {
                                                            setModal({
                                                                Component:
                                                                    () => (
                                                                        <div
                                                                            dangerouslySetInnerHTML={{
                                                                                __html: DOMPurify.sanitize(
                                                                                    atendimento.DS_CASO
                                                                                ),
                                                                            }}
                                                                            className="modalHtml"
                                                                        ></div>
                                                                    ),
                                                                noHeader: true,
                                                                noFooter: true,
                                                                size: "xl",
                                                                scrollable:
                                                                    true,
                                                            });
                                                            setShow(true);
                                                        }}
                                                    >
                                                        <FontAwesomeIcon
                                                            icon={faSearch}
                                                        />
                                                    </span>
                                                )}
                                            </span>
                                            <p className="mb-1 mt-2">
                                                {showDS.length < 350 ? (
                                                    showDS
                                                ) : (
                                                    <>
                                                        {leiaMais.dsCaso
                                                            ? showDS
                                                            : showDS.substr(
                                                                  0,
                                                                  320
                                                              ) + "..."}
                                                        <span
                                                            className="text-primary ml-1 btn p-0"
                                                            onClick={() => {
                                                                setLeiaMais({
                                                                    ...leiaMais,
                                                                    dsCaso: !leiaMais.dsCaso,
                                                                });
                                                            }}
                                                        >
                                                            {leiaMais.dsCaso
                                                                ? "Mostrar Menos"
                                                                : "Leia Mais"}
                                                        </span>
                                                    </>
                                                )}
                                            </p>
                                        </div>
                                    )}
                                    {atendimento.DS_ULTIMO_HISTORICO &&
                                        atendimento.DS_ULTIMO_HISTORICO !==
                                            atendimento.DS_CASO && (
                                            <div className="d-flex flex-wrap flex-column mb-2">
                                                <span className="d-block font-weight-bold mb-1">
                                                    Último Histórico
                                                    {ULTIMO_HIS_IS_HTML && (
                                                        <span
                                                            className="text-primary ml-1 btn p-0"
                                                            onClick={() => {
                                                                setModal({
                                                                    Component:
                                                                        () => (
                                                                            <div
                                                                                dangerouslySetInnerHTML={{
                                                                                    __html: DOMPurify.sanitize(
                                                                                        atendimento.DS_ULTIMO_HISTORICO ||
                                                                                            ""
                                                                                    ),
                                                                                }}
                                                                                className="modalHtml"
                                                                            ></div>
                                                                        ),
                                                                    noHeader:
                                                                        true,
                                                                    noFooter:
                                                                        true,
                                                                    size: "xl",
                                                                    scrollable:
                                                                        true,
                                                                });
                                                                setShow(true);
                                                            }}
                                                        >
                                                            <FontAwesomeIcon
                                                                icon={faSearch}
                                                            />
                                                        </span>
                                                    )}
                                                </span>
                                                <p className="mb-1 mt-2">
                                                    {(showULT_HIS?.length ||
                                                        0) < 350 ? (
                                                        showULT_HIS
                                                    ) : (
                                                        <>
                                                            {leiaMais.historico
                                                                ? showULT_HIS
                                                                : showULT_HIS?.substr(
                                                                      0,
                                                                      320
                                                                  ) + "..."}
                                                            <span
                                                                className="text-primary ml-1 btn p-0"
                                                                onClick={() => {
                                                                    setLeiaMais(
                                                                        {
                                                                            ...leiaMais,
                                                                            historico:
                                                                                !leiaMais.historico,
                                                                        }
                                                                    );
                                                                }}
                                                            >
                                                                {leiaMais.historico
                                                                    ? "Mostrar Menos"
                                                                    : "Leia Mais"}
                                                            </span>
                                                        </>
                                                    )}
                                                </p>
                                            </div>
                                        )}
                                </div>
                            )}
                        </div>

                        <div className="d-flex flex-wrap justify-content-between align-items-center">
                            {props.compactar ? (
                                <span
                                    className="label label-light-info label-inline mr-2 my-1"
                                    style={{ height: "auto" }}
                                >
                                    <FontAwesomeIcon
                                        icon={faHome}
                                        className="mr-1"
                                    />{" "}
                                    {atendimento.PRODUTO.DS_EMPREENDIMENTO} -{" "}
                                    {atendimento.PRODUTO.UNIDADE?.DS_UNIDADE}
                                </span>
                            ) : (
                                <div className="d-flex flex-column mt-3 flex-grow-1">
                                    <label className="text-center text-dark font-weight-bold my-1 mr-5 ">
                                        Produto
                                    </label>
                                    <div className="border-left border-3 border-success pl-3 d-flex flex-wrap align-items-center justify-content-center mr-2 ">
                                        <div className="fixheigth d-flex flex-wrap align-items-center justify-content-center">
                                            <div className="symbol symbol-45 symbol-light-danger">
                                                <div className="symbol-label">
                                                    <FontAwesomeIcon
                                                        icon={faHome}
                                                        size="lg"
                                                    />
                                                </div>
                                            </div>
                                            <div className="text-left ml-2">
                                                <div className="font-size-h6 text-dark-75 font-weight-bolder">
                                                    {
                                                        atendimento.PRODUTO
                                                            .DS_EMPREENDIMENTO
                                                    }
                                                    {atendimento.PRODUTO.UNIDADE
                                                        .VL_PRODUTO &&
                                                        ` - ${atendimento.PRODUTO.UNIDADE.DS_UNIDADE}`}
                                                </div>
                                                <div className="font-size-sm font-weight-bold mt-1">
                                                    {atendimento.PRODUTO.UNIDADE
                                                        .VL_PRODUTO
                                                        ? formatMoneyReais(
                                                              atendimento
                                                                  .PRODUTO
                                                                  .UNIDADE
                                                                  .VL_PRODUTO
                                                          )
                                                        : atendimento.PRODUTO
                                                              .UNIDADE
                                                              .DS_UNIDADE}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {props.children}
                        </div>
                    </div>
                </div>
                {!props.compactar && (
                    <div className="card-footer d-flex align-items-center justify-content-between flex-wrap">
                        <div className="d-flex">
                            <div className="d-flex align-items-center mr-7">
                                <span className="svg-icon svg-icon-gray-500">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24px"
                                        height="24px"
                                        viewBox="0 0 24 24"
                                        version="1.1"
                                    >
                                        <g
                                            stroke="none"
                                            strokeWidth="1"
                                            fill="none"
                                            fillRule="evenodd"
                                        >
                                            <rect
                                                x="0"
                                                y="0"
                                                width="24"
                                                height="24"
                                            ></rect>
                                            <path
                                                d="M16,15.6315789 L16,12 C16,10.3431458 14.6568542,9 13,9 L6.16183229,9 L6.16183229,5.52631579 C6.16183229,4.13107011 7.29290239,3 8.68814808,3 L20.4776218,3 C21.8728674,3 23.0039375,4.13107011 23.0039375,5.52631579 L23.0039375,13.1052632 L23.0206157,17.786793 C23.0215995,18.0629336 22.7985408,18.2875874 22.5224001,18.2885711 C22.3891754,18.2890457 22.2612702,18.2363324 22.1670655,18.1421277 L19.6565168,15.6315789 L16,15.6315789 Z"
                                                fill="#000000"
                                            ></path>
                                            <path
                                                d="M1.98505595,18 L1.98505595,13 C1.98505595,11.8954305 2.88048645,11 3.98505595,11 L11.9850559,11 C13.0896254,11 13.9850559,11.8954305 13.9850559,13 L13.9850559,18 C13.9850559,19.1045695 13.0896254,20 11.9850559,20 L4.10078614,20 L2.85693427,21.1905292 C2.65744295,21.3814685 2.34093638,21.3745358 2.14999706,21.1750444 C2.06092565,21.0819836 2.01120804,20.958136 2.01120804,20.8293182 L2.01120804,18.32426 C1.99400175,18.2187196 1.98505595,18.1104045 1.98505595,18 Z M6.5,14 C6.22385763,14 6,14.2238576 6,14.5 C6,14.7761424 6.22385763,15 6.5,15 L11.5,15 C11.7761424,15 12,14.7761424 12,14.5 C12,14.2238576 11.7761424,14 11.5,14 L6.5,14 Z M9.5,16 C9.22385763,16 9,16.2238576 9,16.5 C9,16.7761424 9.22385763,17 9.5,17 L11.5,17 C11.7761424,17 12,16.7761424 12,16.5 C12,16.2238576 11.7761424,16 11.5,16 L9.5,16 Z"
                                                fill="#000000"
                                                opacity="0.3"
                                            ></path>
                                        </g>
                                    </svg>
                                </span>
                                <span
                                    className="font-weight-bolder text-primary ml-2"
                                    onClick={() => {
                                        setModal({
                                            Component: () =>
                                                HistoricoCardPage({
                                                    ID_CASO:
                                                        atendimento.ID_CASO,
                                                }),
                                            headerComponent: "Históricos",
                                            IconHeader: faHistory,
                                            collapseForm: true,
                                            size: "lg",
                                        });
                                        setShow(true);
                                    }}
                                    role="button"
                                >
                                    {props.hideHistoricoNumber
                                        ? ""
                                        : atendimento.QTD_HISTORICOS}{" "}
                                    Históricos do Caso
                                </span>
                            </div>
                        </div>

                        <div className="d-flex g-2 align-items-center justify-content-center">
                            {props.adicionalButton?.(atendimento)}
                            <Link
                                to={`/${props.moduloAtendimento}/Atendimento/${atendimento.ID_CASO}`}
                                type="button"
                                className="btn btn-outline-primary btn-sm text-uppercase font-weight-bolder mt-5 mt-sm-0 mr-auto mr-sm-0"
                            >
                                <i className="flaticon2-pen "></i> Ver
                                Atendimento
                            </Link>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

export function getAtendimentoTableViewColumns<
    T extends IAtendimentoGenerico = IAtendimentoGenerico
>(
    tipoAtendimento: "ATENDIMENTO" | "COBRANCA",
    columns: Array<ColumnDescription<T>>
) {
    const tableviewColumns: Array<ColumnDescription<T>> = [
        {
            dataField: "DUMMY_FIELD",
            text: "",
            isDummyField: true,
            formatter: (_, row) => (
                <OverlayTrigger
                    overlay={
                        <Tooltip id="ver-atendimento-tooltip">
                            Ver Atendimento
                        </Tooltip>
                    }
                >
                    <Link
                        to={ACESSOS[tipoAtendimento].TELAS.ATENDIMENTO.DS_LINK(
                            row.ID_CASO
                        )}
                        className="m-2 btn btn-icon btn-outline-info"
                    >
                        <FontAwesomeIcon icon={faEye} />
                    </Link>
                </OverlayTrigger>
            ),
        },
        {
            dataField: "ID_CASO",
            text: "Protocolo",
        },
        {
            dataField: "DS_CASO",
            text: "Descrição",
            formatter: (c) => (
                <HTMLRemover
                    charLimit={40}
                    customLeiaMais="+"
                    customLeiaMenos="-"
                >
                    {c}
                </HTMLRemover>
            ),
        },
        {
            dataField: "DT_INICIO",
            text: "Data Inicial",
            formatter: (c) => new Date(c).toLocaleString(),
        },
        {
            dataField: "DT_FIM",
            text: "Data Final",
            formatter: (c) => (c ? new Date(c).toLocaleString() : "-"),
        },
        {
            dataField: "DS_TIPO_CANAL_ATENDIMENTO",
            text: "Canal de Atendimento",
        },
        {
            dataField: "PRODUTO",
            text: "PRODUTO",
            formatter: (c) =>
                `${c?.DS_EMPREENDIMENTO} - ${c?.UNIDADE?.DS_UNIDADE}`,
        },
        {
            dataField: "DS_ATENDENTE",
            text: "Atendente",
        },
        {
            dataField: "CONTA.DS_NOME",
            text: "Cliente",
        },
        {
            dataField: "CONTA.DS_CONTATO",
            text: "Contato",
            formatter: (c) => (c ? c : "-"),
        },
        {
            dataField: "ID_CHAVE_ERP_VENDA",
            text: "Chave ERP",
        },
    ];

    tableviewColumns.push(...columns);

    return tableviewColumns;
}

export default AtendimentoCard;
